import { RuleApiModel } from '~/lib/api/smartsend/types';
import { RuleNames } from './RuleGenerator';

export function GetDefaultRuleByName(rule: RuleApiModel, name: string) {
  return rule.Name === name && rule.Tags.includes(RuleNames.Tag);
}
